//tasks-day-uncover-section.tsx

import { Box, Typography } from "@mui/material";
import TaskGrid from "../task-grid";
import { UncoverTaskRow } from "../../types/task-rows";
import { Tasks } from "../../models/tasks";

interface TasksDayUncoverSectionProps {
  rows: UncoverTaskRow[];
  uncoverColumns: any;
  uncoverColumnOptions: any;
  periodTasksTag?: number;
  periodTasks: Tasks[];
  title: string;
}

export default function TasksDayUncoverSection({
  rows,
  uncoverColumns,
  uncoverColumnOptions,
  periodTasksTag,
  periodTasks,
  title,
}: TasksDayUncoverSectionProps) {
  const trayTotal = periodTasks[0].uncover.reduce((sum, t) => sum + t.trays, 0);

  return (
    <Box>
      {/* ----- HEADER (identical formatting to TasksPage) ----- */}
      <Typography
        variant="h4"
        color="primary"
        sx={{
          pt: 4,
          display: "flex",
          alignItems: "end",
          justifyContent: "space-between",
        }}
      >
        {title}{" "}
        {trayTotal > 0 && (
          <Typography sx={{ float: "right" }} color="black" variant="body1">
            <strong>Trays to Uncover Total: {trayTotal}</strong>
          </Typography>
        )}
      </Typography>

      {/* ----- GRID ----- */}
      <TaskGrid
        key={periodTasksTag}
        taskKey="uncover"
        rows={rows}
        baseColumns={uncoverColumns}
        columnOptions={uncoverColumnOptions}
        rowClassName={(params) => {
          return params.row.batchClass || "";
        }}
      />
    </Box>
  );
}
